// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"247":"02f942a2","538":"c8e26dd5"}[chunkId] || chunkId) + "." + {"50":"fdfcbeffdd9253c1","247":"f19a03602802f710","528":"cbeffd7ef5f7ee1b","538":"e97dfdbd2bb4edd4"}[chunkId] + ".js";
};